import { GradientBackground } from './GradientBackground'

export { GradientBackground }
